import { RMC_PHOTO_GALLERY } from '../tools/Constants'
import { GalleryImage } from '../pages/general/photo-gallery/PhotoGalleryStyles'

// eslint-disable-next-line id-length
const ROBOTICS_PHOTO_GALLERY_INFO: GalleryImage[] = [
	{ image: RMC_PHOTO_GALLERY[0], title: '2025', description: `The team before our first competition run at the University of 
		Central Florida.`},
	{ image: RMC_PHOTO_GALLERY[1], title: '2025', description: 'Temple Robotics volunteering at the FRC competition'},
	{ image: RMC_PHOTO_GALLERY[2], title: '2024', description: `The team before our first competition run at the University of 
		Central Florida.`},
	{ image: RMC_PHOTO_GALLERY[3], title: '2023', description: 'The team after our first competition run at the University of Alabama.' },
	{ image: RMC_PHOTO_GALLERY[4], title: '2023', description: `The leads in front of the project after finishing 
		the outside construction.` },
	{ image: RMC_PHOTO_GALLERY[5], title: '2023', description: `The team worked hard on the design in the fall semester,
		then built the arena over winter break.` },
	{ image: RMC_PHOTO_GALLERY[6], title: '2023', description: `A major goal of 2023 was to construct a practice arena 
		for the robot. Here is the team hard at work!` },
	{ image: RMC_PHOTO_GALLERY[7], title: '2022', description: `The 2022 robot is coming together! No belts yet but the
		chasses is complete.` },
	{ image: RMC_PHOTO_GALLERY[8], title: '2022', description: 'I guess our team has never heard of cable management...' },
	{ image: RMC_PHOTO_GALLERY[9], title: '2022', description: `Us showing off JPL at the 30th anniversary of the NASA
		Space Grant.` },
	{ image: RMC_PHOTO_GALLERY[10], title: '2018', description: 'Our ME\'s filing away to make sure everything fits perfectly.' },
	{ image: RMC_PHOTO_GALLERY[11], title: '2018', description: 'BoxBot, of course we still love you.' },
	{ image: RMC_PHOTO_GALLERY[12], title: '2017', description: `Our team plugged the ethernet cable into the wrong port. 
		Good thing duct tape fixes everything!` },
	{ image: RMC_PHOTO_GALLERY[13], title: '2017', description: `Our hotel didn't like us working on the robot in our rooms. 
		I guess we'll just use our vans.` },
	{ image: RMC_PHOTO_GALLERY[14], title: '2011', description: `The year our team's autonomous was so good they had to
		change the rules.` },
	{ image: RMC_PHOTO_GALLERY[15], title: '2010', description: 'Scoops was born.' },
	{ image: RMC_PHOTO_GALLERY[16], title: '2009', description: 'Our first team at the very first Robotics Mining Competition.' }
]

export default ROBOTICS_PHOTO_GALLERY_INFO

